module.exports = __webpack_public_path__ + "static/media/dashboard-sponsor.24606d50.svg";